<div class="ui-progress">
  <div
    class="ui-progress__track"
    [style.height.px]="height()"
    role="progressbar"
    [attr.aria-valuenow]="clamped()"
    aria-valuemin="0"
    aria-valuemax="100"
  >
    <div
      class="ui-progress__fill ui-progress__fill--{{ variant() }}"
      [style.width.%]="clamped()"
    ></div>
  </div>
  @if (showLabel()) {
    <span class="ui-progress__label">{{ clamped() }}%</span>
  }
</div>
